import { LearningMaterials } from "UIPalette/LearningMaterials/LearningMaterials";
import { ReactComponent as RightChevron } from "shared/assets/Icons/right.svg";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { WellKnownLearningMaterialCategory } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export type ArticleCategoryListProps = {
  heading: string;
  description: string;
  category: WellKnownLearningMaterialCategory;
  ariaLabel: string;
};

export const ArticleCategoryList = ({ heading, description, category, ariaLabel }: ArticleCategoryListProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <RoundedCard>
      <button
        className="w-full mb-4 text-left"
        onClick={() => {
          navigate(`/${category.path}/`);
        }}
      >
        <h2>{heading}</h2>
        <div className="flex items-center justify-between gap-4">
          <p>{description}</p>
          <div>
            <RightChevron className="text-grey" />
          </div>
        </div>
      </button>
      <div className={"mt-2"}>
        <LearningMaterials
          categoryIds={[category.id]}
          maxResults={4}
          resultsPerPage={4}
          navigateBasePath={`/${category.path}/`}
          errorMessage={t("resources.articileLibraryErrorButton")}
          ariaLabel={ariaLabel}
        />
      </div>
    </RoundedCard>
  );
};
